import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => {

	return {
		topProfileContainer: {
			display      : "flex",
			padding      : "2rem",
			alignItems   : "center",
			marginBottom : "1rem",

			[rooterMediaQuery.mobile]: {
				padding: "1rem"
			}
		},
		imageBanner: {
			width        : "10rem",
			height       : "10rem",
			borderRadius : "50%",

			[rooterMediaQuery.mobile]: {
				width  : "5rem",
				height : "5rem"
			}
		},
		imageBannerActive: {
			width                     : "10rem",
			height                    : "10rem",
			objectFit                 : "contain",
			border                    : "2px solid #126bd5",
			position                  : "relative",
			borderRadius              : "50%",
			padding                   : "1px",
			cursor                    : "pointer",
			[rooterMediaQuery.mobile] : {
				width  : "5rem",
				height : "5rem"
			}
		},
		infoContainer: {
			display       : "flex",
			flexDirection : "column",
			maxWidth      : "900px"
		},
		avatarContainer: {
			position : "relative",
			margin   : "0 7rem 0 5rem",

			[rooterMediaQuery.tablet]: {
				margin: "0 3rem"
			},

			[rooterMediaQuery.mobile]: {
				margin: "0 1.2rem 0 0"
			}

		},
		liveButton: {
			border          : theme.other.darkMode ? "none" : "1px solid white",
			width           : "40px",
			color           : "white",
			left            : "50%",
			transform       : "translate(-50%,0)",
			position        : "absolute",
			bottom          : "0",
			display         : "flex",
			justifyContent  : "center",
			alignItems      : "center",
			fontWeight      : "500",
			borderRadius    : "5px",
			cursor          : "pointer",
			backgroundImage : "linear-gradient(rgb(18, 107, 213), rgb(67, 154, 255))"
		},
		liveText: {
			letterSpacing : "1px",
			fontSize      : "12px"
		},
		bio: {
			color           : theme.other.paletteNew.secondaryDarkGrey,
			fontSize        : "1.3rem",
			display         : "-webkit-box",
			WebkitBoxOrient : "vertical",
			WebkitLineClamp : 2,
			overflow        : "hidden"
		},
		name: {
			marginRight : "0.5rem",
			fontWeight  : "500",
			fontSize    : "1.5rem",
			cursor      : "pointer"
		},
		verifiedIcon: {
			width  : "10px",
			heihgt : "10px"
		},
		followerCountNumber: {
			marginRight : "0.2rem",
			fontSize    : "1.2rem",
			width       : "fit-content"
		},

		followersInfoContainer: {
			display : "flex",
			margin  : "0.5rem 0"
		},

		// mobile css
		mobileContainer: {
			padding       : "0 1.6rem",
			paddingBottom : "1rem"
		},

		userInfoContainer: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "space-between",
			marginBottom   : "0.4rem"
		},

		profileAndInfoContainer: {
			display    : "flex",
			width      : "75%",
			alignItems : "center"
		},

		followButton: {
			[rooterMediaQuery.mobile]: {
				borderRadius: "0.4rem"
			}
		},
		infoBtnContainer: {
			display : "flex",
			gap     : "1rem",

			[rooterMediaQuery.desktop]: {
				gap: "3rem"
			}
		},
		mobileCreatorNameAndFollowerInfo: {
			width: "inherit"
		}
	};
}, { name: "creator-profile" } );

